import { create } from 'zustand';

interface GalleryStore {
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  sliderId: string | null;
  setSliderId: (id: string | null) => void;
}

export const useGalleryStore = create<GalleryStore>(set => ({
  currentIndex: 0,
  setCurrentIndex: (index: number) => set({ currentIndex: index }),
  sliderId: null,
  setSliderId: (id: string | null) => set({ sliderId: id }),
}));
